<template>
    <div class="pa-4">
        <h1 class="mb-5 text--xl font-weight-medium">{{ $t('navigation.statuses') }}</h1>
        <FiltersBar :withFilters="false"
                    ref="filtersBar"></FiltersBar>

        <StatusesTable @change-page="changePage($event)"
                     @change-amount="changeAmount($event)"
                     @sort="sortingColumn = $event"
                     @fetch="fetchIncidentsStatuses"
                     :loader="loader"
                     :changed-page="pagination.page"></StatusesTable>

        <ManageIncidentStatus @fetch="fetchIncidentsStatuses"></ManageIncidentStatus>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import StatusesTable from '@/components/incidentsStatuses/StatusesTable';
import FiltersBar from '@/components/widgets/tables/FiltersBar';
import ManageIncidentStatus from '@/components/incidentsStatuses/ManageIncidentStatus';

export default {
    name: 'IncidentsStatusesConfigurations',
    components: { StatusesTable, FiltersBar, ManageIncidentStatus },
    data: () => ({
        pagination: {
            page: 1,
            amount: 20
        },
        loader: false,
        sortingColumn: null
    }),
    computed: {
        ...mapFields('search', [
            'search'
        ])
    },
    watch: {
        sortingColumn: {
            handler () {
                this.fetchIncidentsStatuses();
            },
            deep: true
        },
        search: {
            handler (val, oldVal) {
                if ((val && val.length >= 2) || (oldVal && val === '')) {
                    this.pagination.page = 1;
                    this.fetchIncidentsStatuses();
                }
            }
        }
    },
    methods: {
        fetchIncidentsStatuses () {
            this.loader = true;

            const params = {
                'page[number]': this.pagination.page,
                'page[size]': this.pagination.amount
            };

            if (this.sortingColumn) {
                params.sort = this.sortingColumn.value === 'asc' ? this.sortingColumn.name : `-${this.sortingColumn.name}`;
            }

            if (this.search) {
                params['filter[name][prefix]'] = this.search;
            }

            this.$store.dispatch('incidents/getIncidentStatuses', params)
                .finally(() => {
                    this.loader = false;
                });
        },
        changePage (event) {
            this.pagination.page = event;
            this.fetchIncidentsStatuses();
        },
        changeAmount (event) {
            this.pagination.page = 1;
            this.pagination.amount = event;
            this.fetchIncidentsStatuses();
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$can(vm.$abilityActions.READ, vm.$abilitySubjects.INCIDENT_STATUS)) {
                vm.fetchIncidentsStatuses();
            } else {
                vm.$router.push({ name: 'home' });
            }
        });
    },
    beforeRouteLeave (to, from, next) {
        this.$store.dispatch('filters/clearFiltersParams');
        this.search = null;
        next();
    }
};
</script>

<style scoped>

</style>
